import styled, { css, StyledComponent } from 'styled-components';

export const SortIconWrapper: StyledComponent<'div', any, { visible?: boolean }> = styled.div<{
  visible?: boolean;
}>`
  ${({ visible }) => {
    if (!visible)
      return css`
        display: none;
      `;
    return;
  }}
`;

export const CommonHeaderRendererWrapper: StyledComponent<
  'div',
  any,
  { sortEnabled?: boolean }
> = styled.div<{ sortEnabled?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #000;

  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 12px;

  ${({ sortEnabled }) => {
    if (sortEnabled) {
      return css`
        &:hover {
          cursor: pointer;

          ${SortIconWrapper} {
            display: block;
          }
        }
      `;
    }
    return;
  }}
`;

export const CheckboxHeaderRendererWrapper: StyledComponent<'div', any> = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #000;
  padding-top: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const RowNumberHeaderRendererWrapper: StyledComponent<'div', any> = styled.div`
  cursor: default;
  font-weight: 600;
  font-size: 14px;
  padding: 12px 0;
`;

export const SelectableHeaderRendererWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  flex-direction: column;

  padding-bottom: 12px;
  width: 100%;
`;

export const DateHeaderRendererWrapper: StyledComponent<'div', any> = styled.div`
  display: flex;
  flex-direction: column;

  padding-bottom: 12px;
  width: 100%;
`;
